import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { IDriverClassificationQuery } from "../../models/driver-classification/query";
import {
  IDriverClassification,
  IDriverClassificationDetails,
} from "../../models/driver-classification/response";
import {
  ICreateDriverClassification,
  IUpdateDriverClassification,
} from "../../models/driver-classification/request";

export type DriverClassificationLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: DriverClassificationLoading[];

  list?: IBaseListingResponse<IDriverClassification>;
  query: IDriverClassificationQuery;

  details?: IDriverClassificationDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IDriverClassification) => void;

    createDriverClassification: (
      request: ICreateDriverClassification
    ) => void;
    updateDriverClassification: (
      id: number,
      request: IUpdateDriverClassification
    ) => void;
    deleteDriverClassification: (id: number) => void;
    exportExcel: (data: any) => any;

    setSearch: (search?: string) => void;
    setQuery: (query: IDriverClassificationQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    exportExcel: DEFAULT_FUNCTION,

    createDriverClassification: DEFAULT_FUNCTION,
    updateDriverClassification: DEFAULT_FUNCTION,
    deleteDriverClassification: DEFAULT_FUNCTION,

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const DriverClassificationContext = createContext(externalState);

export default DriverClassificationContext;
